import React from 'react'
import { cx, css } from 'emotion'
import AntSteps, { StepsProps, StepProps } from 'antd/es/steps'
import 'antd/es/steps/style/css'
import {
  baseStyle,
  ActiveDesktopStepperStyle,
  InactiveDesktopStepperStyle,
} from 'src/constants/fontStyles'

const DesktopSteps = ({
  className,
  ...rest
}: StepsProps & {
  children: React.ReactNode
}) => {
  const style = `
      & .ant-steps-item-title {
        padding-right: 0;
      }
  
      & .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
        ${baseStyle}
        ${InactiveDesktopStepperStyle}
      }
  
      & .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
        ${baseStyle}
        ${ActiveDesktopStepperStyle}
      }
  
      & .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
        background: #43CC32;
      }
  
      &.ant-steps-dot .ant-steps-item-icon {
        width: 13px;
        height: 13px;
      }
  
      &.ant-steps-dot .ant-steps-item-content {
        width: unset;
        max-width: 100%;
      }
  
      &.ant-steps-dot .ant-steps-item-process .ant-steps-item-icon {
        width: 13px;
        height: 13px;
      }
  
      &.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {
        margin-top: 6px;
      }
  
      &.ant-steps-dot .ant-steps-item-tail::after {
        margin-left: 15px;
      }
  
      & .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
        background: #CACACA;
      }
  
      &.ant-steps-vertical.ant-steps-dot .ant-steps-item-process .ant-steps-icon-dot {
        top: 0;
      }
  
      &.ant-steps-vertical .ant-steps-item-icon {
        margin-right: 10px;
      }
  
      &.ant-steps-vertical.ant-steps-dot .ant-steps-item-process .ant-steps-icon-dot {
        left: 0;
      }
  
      & .ant-steps-item-icon > .ant-steps-icon {
        top: 0;
      }
  
      &.ant-steps-vertical.ant-steps-dot .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
        top: 4px;
        left: -9px;
      }
  
      & .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after {
        background: #CACACA;
      }
  
      & .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
        ${baseStyle}
        ${InactiveDesktopStepperStyle}
        color: #777777;
      }
    `

  return <AntSteps {...rest} className={cx(css(style), className)}></AntSteps>
}

const DesktopStep: React.FC<StepProps> = ({ ...props }) => {
  const ellipseStyle = css`
    & .ant-steps-item-title {
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `
  return <AntSteps.Step className={cx(ellipseStyle)} {...props}></AntSteps.Step>
}
DesktopSteps.Step = DesktopStep

export default DesktopSteps
